module.exports = __webpack_public_path__ + "static/media/arrow-back-experience.2dd88bce.svg";